import React from "react";
import {ICreateExpenseData} from "../../@types";
interface expenseDetailsProp {
  expense: ICreateExpenseData;
  isBillable: boolean;
}
export const ExpenseDetails: React.FC<expenseDetailsProp> = ({ expense, isBillable }) => {
  return (
    <>
    <div className="md:gap-[100px] xl:gap-[100px] flex-flex-col justify-between lg:gap-[50px] px-[61px] pt-[35px] hidden sm:flex mt-[24px] bg-[#EDF2F5] shadow-md shadow-color-gray-200 w-[350px] mx-auto sm:mx-0 h-full sm:w-auto sm:h-auto lg:w-[890px] lg:h-[184px] ">
      <div className=" flex flex-col ">
        <h3 className="font-normal not-italic text-[#000000]   md:text-[12px]  leading-6 tracking-wide  ">Vendor:</h3>
        <p className="font-semibold not-italic text-[#000000]  text-xs leading-6 tracking-wide "> {expense?.vendorName}</p>
        <h3 className="font-normal not-italic text-[#000000]  md:text-[12px] leading-6 tracking-wide mt-[23px] ">
          Expense Category:
        </h3>
        <p className="font-semibold text-[#000000]  not-italic text-xs leading-6 tracking-wide ">
          {expense?.category}
        </p>
      </div>
      <div className="flex flex-col  ">
        <h3 className="font-normal text-[#000000] not-italic  md:text-[12px] leading-6 tracking-wide gap-[9px] ">
          Payment Method:
        </h3>
        <p className="font-semibold text-[#000000]  text-xs leading-5  tracking-wide whitespace-nowrap ">
          {expense?.paymentMethod}
        </p>
        <h3 className="font-normal text-[#000000] not-italic  md:text-[12px]  leading-6 tracking-wide mt-[23px] ">
          Reference:
        </h3>
        <p className="font-semibold text-[#000000]  text-xs leading-5 tracking-wide ">{expense?.reference}</p>
      </div>
      <div className="flex flex-col ">
        <h3 className="font-normal text-[#000000] not-italic   md:text-[12px]  leading-6 tracking-wide gap-[9px]  ">
          Billed to:
        </h3>
        <p className="font-semibold text-[#000000]  text-xs leading-5  tracking-wide whitespace-nowrap">{expense?.customerName ? expense?.customerName : "N/A"}</p>
        <h3 className="font-normal text-[#000000] not-italic  md:text-[12px] leading-6 tracking-wide mt-[23px] ">
          Notes
        </h3>
        {expense?.notes ? (
          <p className="font-semibold text-[#000000] text-xs leading-5 tracking-wide">
            {expense?.notes}
          </p>
        ) : (
          <p className="font-semibold text-[#000000] text-xs leading-5 tracking-wide ">N/A</p>
        )}
      </div>
    </div>

 {/* mobile view */}
 <div className="flex sm:hidden  mt-[24px]  bg-[#EDF2F5] shadow-md shadow-color-gray-200 w-[350px] mx-auto sm:mx-0 h-full sm:w-auto sm:h-auto lg:w-[890px] lg:h-[184px] ">
    <div className="flex flex-row py-5 gap-[6em]">

      <div className="flex flex-col gap-6 pl-3">
       <div className="flex flex-col">
        <h3 className="font-normal not-italic text-[#000000]  text-[12px]  leading-6 tracking-wide  ">Vendor:</h3>
        <p className="font-bold not-italic text-[#000000] text-xs   leading-6 tracking-wide "> {expense?.vendorName}</p>
       </div>
        <div className="flex flex-col">
          <h3 className="font-normal not-italic text-[#000000]  text-[12px] leading-6 tracking-wide ">
          Expense Category:
        </h3>
        <p className="font-bold text-[#000000]  not-italic text-xs leading-6 tracking-wide ">
          {expense?.category}
        </p>
        </div>
        
        <div className="flex flex-col">
          <h3 className="font-normal text-[#000000] not-italic lg:text-xs text-[12px] leading-6 tracking-wide gap-[9px] ">
            Billed to:
        </h3>
        <p className="font-bold text-[#000000]  text-xs leading-5  tracking-wide whitespace-nowrap ">
          {expense?.billedTo}
        </p>
        </div>
        <div className="flex flex-col">
          <h3 className="font-normal text-[#000000] not-italic text-[12px] lg:text-xs leading-6 tracking-wide gap-[9px] ">
            Notes
        </h3>
        <p className="font-bold text-[#000000]  text-xs leading-5  tracking-wide whitespace-nowrap ">
          {expense?.notes}
        </p>
        </div>     
      </div>

      <div className="flex flex-col gap-6">
      <div className="flex flex-col">
          <h3 className="font-normal text-[#000000] not-italic text-[12px] lg:text-xs leading-6 tracking-wide gap-[9px] ">
            Payment method:
        </h3>
        <p className="font-bold text-[#000000]  text-xs leading-5  tracking-wide whitespace-nowrap ">
          {expense?.paymentMethod}
        </p>
        </div>

        <div className="flex flex-col">
          <h3 className="font-normal text-[#000000] not-italic text-[12px] lg:text-xs leading-6 tracking-wide gap-[9px] ">
            Reference
        </h3>
        <p className="font-bold text-[#000000]  text-xs leading-5  tracking-wide whitespace-nowrap ">
          {expense?.reference}
        </p>
        </div>
      </div>

    </div>
      
     </div>
    </>
    

  );
};
